import { PC_MESSAGES, USER_MESSAGES } from '../utils/messages';
import { isValid, waitSeconds } from '../utils/utilitiesmodule';
import { useWebSocket } from '@vueuse/core';
import { WebSocketInfo } from './WebSocketInfo';
import { ClientMessage } from '../utils/objects';
/*
Questo oggetto viene instanziato in main.js chiamando checkSocket().
Dopo una chiamata, a seconda dei casi, 
- si attende la risposta e la ritorna;
- ritorna "true"
*/
export class WebSocketClient {

    // auth è l'oggetto restituito dalla chiamata di login
    //https://vueuse.org/core/useWebSocket/
    constructor(auth, emitFunction, translateFunction) {
        this.responses={}; // oggetto tipo { [messaggio chiamata socket] : [risposta alla chiamata]}
        this.lastMessage="";

        var idLicense=auth.id_master_account;
        var token=auth.access_token;

        this.url=process.env.VUE_APP_WEBSOCKET+"?cll=C_"+idLicense; //"ws://192.168.0.91:4003/enterprise/websocket?cll=C_" + idLicense; //"ws://192.168.0.254:4003/enterprise/websocket?cll=C_" + idLicense;  
        this.emitFunction=emitFunction;
        this.translateFunction=translateFunction;
        this.idPC=null;
        this.error=false;
        this.websocket=null;

        let self=this;
        this.manualAutoreconnect={
            maxAttempts: 50,
            attempt: 0
        };


        this.config={
            autoReconnect: false/*{
                retries: 50,
                delay: (attempt) => {

                    return Math.min(delay, 60000); // massimo 60s
                },
                onFailed: function() {
                    self.websocket=null;
                    console.log('Failed to connect WebSocket ');
                    self.checkConnection();
                }
            }*/,
            heartbeat: {
                message: 'ping',
                interval: 20000,
                pongTimeout: 20000
            },
            autoClose: false,
            onConnected: function(ws) {
                self.manualAutoreconnect.attempt=0;

                console.info("Connected");

                self.responses["CHECKCONNECTION"]=true;
                self.websocket=ws;
                ws.send(JSON.stringify({ "msg": "track", "token": token }));
                self.emitFunction("socketEventConnected");
            },
            onDisconnected: function(ws) {
                console.warn("WebSocket Disconnected");

                self.emitFunction("socketEventDisconnected");
                self.responses["CHECKCONNECTION"]=false;
                self.websocket=null;
                var info;
                //Popolo tutte le richieste in pending con il valore di default
                Object.keys(self.responses).forEach(k => {
                    if (self.responses[k]==null) {
                        info=WebSocketInfo.buildInfo(k, false, false, { text: PC_MESSAGES.NOT_CONNECTED, msgType: "ERROR", msgArgs: null });
                        if (info==null) info={ result: false };

                        self.responses[k]=info;
                    }
                });
                self.delayFunction();

            },
            onError: function(ws, e) {
                console.writeError("WebSocket", e);

                self.error=true;
                self.websocket=null;

            },
            onMessage: (_, event) => self.onMessageCallback(event.data)
        }
    }

    delayFunction() {
        this.manualAutoreconnect.attempt++;
        if (this.manualAutoreconnect.attempt==this.manualAutoreconnect.maxAttempts) {
            this.manualAutoreconnect.attempt=0;
        }

        var delay=Math.ceil(this.manualAutoreconnect.attempt/5)*5000;
        console.log("Tentativo di riconnessione : {0} tra {1} ms".format(this.manualAutoreconnect.attempt, delay));
        setTimeout(() => {
            this.checkConnection();
        }, delay)
    }


    //Metodo void
    //La risposta verrà restituita emettendo
    //    - "socketEventConnected" se la risposta è positiva. Verrà emesso se la connessione è già attiva o al momento della connessione
    //    - "socketEventDisconnected" se la risposta è negativa. Verrà emesso se la connessione non va a buon fine
    async checkConnection() {
        let self=this;
        //Caso 1 : Si deve istanziare l'oggetto websocket
        if (self.websocket==null) {
            try {
                useWebSocket(this.url, this.config);
                return true;
            } catch (e) {
                console.writeError(e);
                this.emitFunction("socketEventDisconnected");
                return false;
            }
        }

        var s;
        switch (self.websocket.readyState) {
            //Caso 0 - CONNECTING: Attendo per un massimo di 30 secondi che la connessione si stabilizzi
            // Se dopo questi 30 secondi webSocket non è connesso, ricontrollo per un massimo di 5 volte la connessione,
            // in modo da agire correttamente in base allo stato della connessione
            // Se questi 5 tentativi falliscono, c'è qualche problema con la connessione
            case 0:
                for (s=0; s<=30; s++) {
                    if (self.websocket.readyState==1) {
                        self.emitFunction("socketEventConnected");
                        return true;
                    }
                    await waitSeconds(1);
                }

                this.emitFunction("socketEventDisconnected");
                return false;
            //Caso 1 - CONNECTED : la connessione è stabile
            case 1: //connected
                self.emitFunction("socketEventConnected");
                return true;

            //Caso 2 - CLOSING: La connessione si sta chiudendo, quindi attendo per un massimo di 30 secondi che si chiuda
            // Se dopo questi 30 secondi webSocket è non è disconnesso, ricontrollo per un massimo di 5 volte la connessione,
            // in modo da agire correttamente in base allo stato della connessione
            // Se questi 5 tentativi falliscono, c'è qualche problema con la connessione
            case 2:
                for (s=0; s<=30; s++) {
                    if (self.websocket.readyState==3) {
                        self.emitFunction("socketEventDisconnected");
                        self.websocket=null;
                        return await this.checkConnection();
                    }
                    await waitSeconds(1);
                }

                this.emitFunction("socketEventDisconnected");
                return false;

            //Caso 3 - CLOSED : la connessione è chiusa definitivamente, quindi provo ad istanziarla
            case 3:
            default:
                self.websocket=null;
                return await this.checkConnection();
        }

    }


    async call(message, arg1, arg2, arg3) {
        //console.log("Chiamata WebSocket " + message + " " + (arg1 != undefined ? arg1 : "") + " " + (arg2 != undefined ? arg2 : ""));

        let self=this;
        var upperCaseMessage=message.toUpperCase();
        var seconds=0;
        var info;

        if (this.websocket==null) {
            return WebSocketInfo.buildInfo(upperCaseMessage, false, false, ClientMessage.error(PC_MESSAGES.NOT_CONNECTED, null, upperCaseMessage));
        }
        self.responses[upperCaseMessage]=null;
        self.lastMessage=upperCaseMessage;

        var request;

        //Step 1 : si popolano request e info
        //Caso 1 : subscribe: invio la richiesta e ritorno true
        if (message=="subscribe_pc") {
            this.idPC=arg1;
            request={
                "msg_type": "msg",
                "msg": "subscribe_pc",
                "pc_id": arg1
            };

            info=WebSocketInfo.buildInfo(upperCaseMessage, true, false);

        } else if (message=="unsubscribe_pc") { //Caso 2 : unsubscribe
            request={
                "msg_type": "msg",
                "msg": "unsubscribe_pc",
                "pc_id": arg1
            };

            info={
                waitResponse: true, //attendo {msg: 'unsubscribe_pc', msg_type: 'request_status', result: 'true'}

            }

        } else { //CASO 3 : altro tipo di chiamata //MA: ho inserito una modifica per passare l'arg1 al recipient ID da "fuori" il computer
            request={
                "msg_type": "command",
                "command": message,
                "recipient": "agent",
                "recipient_id": this.idPC!=null? this.idPC:arg1
            };

            info=WebSocketInfo.buildInfo(upperCaseMessage, true, false, null, arg1, arg2, arg3);
            request.command=message;

            if (info.data) request.data=info.data;
        }

        //Step 2 : si avvia la chiamata

        try {
            if (/*await this.checkConnection()*/this.websocket.readyState==1/* await this.checkConnection()*/) {
                this.websocket.send(JSON.stringify(request));
            } else {

                console.debug("this.websocket.readyState = "+this.websocket.readyState);
                info=WebSocketInfo.buildInfo(upperCaseMessage, false, false, ClientMessage.error(PC_MESSAGES.NOT_CONNECTED, null, upperCaseMessage)/*{ text: PC_MESSAGES.NO_RESPONSE+" "+upperCaseMessage, msgType: "ERROR", msgArgs: null }*/);
                return info;
            }
        } catch (e) { alert(e); }


        if (!info.waitResponse) {
            return info;
        }

        //Step 3 : Per un massimo di 60 secondi, attendo la risposta
        for (seconds=1; seconds<=60; seconds++) {

            //Caso 1 : se la risposta è arrivata, la ritorno
            if (self.responses[upperCaseMessage]!=null && self.responses[upperCaseMessage]!= "__WAIT__") {
                return self.responses[upperCaseMessage];
            }

            //Caso 2 : disconnesso -> modifico info e lo ritorno
            if (self.websocket.readyState!=1) {
                info=WebSocketInfo.buildInfo(upperCaseMessage, false, false);
                if (info==null) { info={}; }
                info.message=ClientMessage.error(USER_MESSAGES.NOT_CONNECTED, null, upperCaseMessage);
                return info;
            }

            //Caso 3 : ho ricevuto wait -> si sta processando la richiesta, quindi posso resettare seconds e ricominciare ad aspettare al massimo 60 secondi 
            if (self.responses[upperCaseMessage]== "__WAIT__") {
                seconds=1;
                self.responses[upperCaseMessage]=null;
            }

            self=this;
            console.debug(upperCaseMessage + " - Wait a second");
            await waitSeconds(1);

        }

        console.debug("seconds = "+seconds);
        console.writeError(PC_MESSAGES.NO_RESPONSE+" : "+upperCaseMessage);
        info=WebSocketInfo.buildInfo(upperCaseMessage, false, false, ClientMessage.error(PC_MESSAGES.NO_RESPONSE, null, upperCaseMessage));
        return info;

    }

    /**
     Nell'oggetto di risposta di una chiamata socket, prendo in considerazione il campo msg_type
     {
        msg_type : "data" / message / request_status / command_status / command,
        message / msg/ command
        data / result
        recipient = "multiple"
        id_pc -> solo se msg_type == "data" o message
    }
    */
    async onMessageCallback(data) {
        if (data=="pong") {
            this.lastPong=Date.now();
            return; //TODO:GESTIRE LA CONNESSIONE DA QUI!!!
        }

        data=JSON.parse(data);

        if (!["message", "request_status", "command_status"].includes(data.msg_type)&&!["rt_restores", "rt_runningRestores", "rt_systemData", "rt_processesList", "rt_jobs", "rt_runningJobs", "rt_jobOrder", "wuData"].includes(data.message)) {
            console.debug(data);
        }

        switch (data.msg_type) {
            case "request_status":
                this.onMessageCallback_RequestStatus(data.msg.trim(), data.result);
                break;

            //Risposta dal server
            case "command_status": // non devo far nulla se data.result == true
                this.onMessageCallback_CommandStatus(data.command.trim(), data.result);
                break;

            //Risposta dall'agent
            //{
            //     msg_type = "data"
            //     message 
            //     parent_command 

            //     data 
            //     recipient 
            //     recipient_id 
            //     session_id 
            // }
            case "data":
                if (data.parent_command!="StartSendInfo") {
                    console.debug(data.parent_command+" -> "+data.message);
                }

                if (data.pc_id==this.idPC) {
                    this.onMessageCallback_Data(data.parent_command, data.message.trim(), data.data);
                }
                break;

            // {
            //     msg_type = "message"
            //     message = {
            //          text
            //          msgArgs
            //          msgType
            //        }
            //     recipient 
            //     recipient_id 
            //     scope 
            //     parent_command 
            // }
            case "message": // messaggi in realtime
                if (data.pc_id==this.idPC) {
                    this.onMessageCallback_Message(data.parent_command, data.message);
                }
                break;
            case "cmd":
                this.onMessageCallback_CommandPrompt(data.parent_command, data.message);
                break;
        }
    }

    async onMessageCallback_Data(parent_command, message, data) {

        if (!isValid(parent_command)) {
            console.writeError("parent_command di "+message+" è undefined");
            return;
        }

        parent_command=parent_command.toUpperCase();

        if (parent_command!="STARTSENDINFO") {
            this.responses[parent_command]=WebSocketInfo.buildInfo(parent_command, false, true, null, data);
            return;
        }

        switch (message) {
            //12/12/2024 - Veronica : Ho diviso i dati in realtime per gestirli meglio in Computer.js (prima c'era solo rtData)
            case "rt_systemData": //dati in realtime che verranno catturati da Computer.js
                this.emitFunction("addRealTimeSystemDataToPage", data);
                break;
            case "rt_processesList":
                // case "rtData": //dati in realtime che verranno catturati da Computer.js
                this.emitFunction("addRealTimeProcessesToPage", data);
                break;

            case "rt_jobs": // jobs in realtime
                //Verrà catturata da Computer.js
                //data è una mappa in cui le chiavi sono gli id dei job e i valori sono i job
                //https://stackoverflow.com/questions/4215737/how-to-convert-an-array-into-an-object
                this.emitFunction("addBackupsToPage", data);
                break;
            case "rt_runningJobs":
                this.emitFunction("SETPAGEPROP", "running_backups", data);
                break;
            case "rt_jobOrder":
                this.emitFunction("addIDsOrder", data);
                break;

            case "rt_restores": // restore in realtime
                // Verrà catturata da Computer.js e dalle dialog di restore
                this.emitFunction("addRestoreToPage", data);
                break;
            case "rt_runningRestores":
                this.emitFunction("SETPAGEPROP", "running_restores", data);
                break;

            case "wuData": // restore in realtime
                // Verrà catturata da Computer.js
                this.emitFunction("addWUToPage", data);
                break;
        }
    }


    onMessageCallback_CommandPrompt(parent_command, message) {
        if (parent_command=="closecmd") {
            this.emitFunction("closeCMD");
        }
        if (parent_command=="runcmd") {
            this.emitFunction("runCMD", message.text);
        } else {
            this.responses[parent_command.toUpperCase()]={ result: message }
        }
    }

    onMessageCallback_Message(command, message) {

        //CASO 1 : Il messaggio è la risposta ad un comando inviato
        if (isValid(command)) {
            this.onMessageCallback_Message_WithCommand(message, command);
            return;
        }

        //Verrà visualizzato nell'apposito componente
        if (message.isFeedbackMessage) {
            this.emitFunction("sendClientMessage", message, message.command);
        } else {
            this.emitFunction("realtimeMessages", message);
        }

        if (message.msgType=="WAIT" && isValid(message.command)) {
            this.responses[message.command.toUpperCase()]="__WAIT__";
        }

    }

    onMessageCallback_Message_WithCommand(message, command) {
        var ok=message.msgType!="ERROR";
        var uppercaseCommand=command.toUpperCase();
        this.responses[uppercaseCommand]=WebSocketInfo.buildInfo(uppercaseCommand, false, ok, message);

    }

    onMessageCallback_CommandStatus(command, result) {

        var uppercaseCommand=command.toUpperCase();
        //Caso 1 : command è un comando che attende solamente una riposta di tipo command_status.
        // result determina lo stato della connessione.
        // Visualizzo un messaggio solo se non si è connessi
        if (["STARTSENDINFO", "STOPSENDINFO"].includes(uppercaseCommand)) {
            this.responses[uppercaseCommand]={
                result: result=="true"
            };
            return;
        }

        //Caso 2 : Se command_status == "false", non si è connessi, quindi
        if (result=="false") {
            //prendo l'oggetto di default, poiché contiene il result di default
            var info=WebSocketInfo.buildInfo(uppercaseCommand, false, false, { text: PC_MESSAGES.NOT_CONNECTED, msgType: "ERROR", msgArgs: null });
            // ne modifico i campi relativi allo stato della connessione
            this.responses[uppercaseCommand]=info;
        }
    }

    async onMessageCallback_RequestStatus(message, result) {
        if (message=="track") {
            console.info(result);
            return;
        }

        message=message.toUpperCase();
        switch (message) {
            case "SUBSCRIBE_PC":
            case "UNSUBSCRIBE_PC":
                this.responses[message]={
                    result: result=="true"
                };
                return;
        }

        //caso non gestito
        console.writeError("onMessageCallback_RequestStatus di "+message+"non gestito");
        return null;
    }

}